import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { lightBlue } from '@mui/material/colors';
import { useNavigate } from 'react-router';
import { showErrorToast } from "../../Utils/toastUtils";

const primary = lightBlue[200];

export default function PageNotFound() {
  let navigate = useNavigate();

  showErrorToast("Page Not Found")
  const backHome = () => {
    navigate(-1)

  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: primary,
      }}
    >
      <Typography variant="h1" style={{ color: 'white' }}>
        404
      </Typography>
      <Typography variant="h6" style={{ color: 'white' }}>
        The page you’re looking for doesn’t exist.
      </Typography>
      <Button onClick={backHome} variant="contained">Back Home</Button>
    </Box>
  );
}
